
        Component.define('pet-benefits', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el             = $(el);
const $slider         = $el.find('.wrapper-slider');

$slider.slick({
    infinite: true,
    slidesToShow: 4,
    dots: false,
    arrows: true,
    responsive: [
        {
          breakpoint: 980,
          settings: {
            slidesToShow: 1,
            infinite: true,
          }
        },
    ]  
});

        });